import lyzTable from './lyz-table';

export default {
  install: Vue => {
    Vue.component('lyzTable', lyzTable)
  }
}